module.exports = __webpack_public_path__ + "img/rot01.5faf979f.jpg";